var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13632 0.413775C7.67009 0.102412 8.33012 0.102411 8.86389 0.413773L14.5782 3.7471C15.1048 4.05433 15.4287 4.61816 15.4287 5.22787V10.7722C15.4287 11.3819 15.1048 11.9457 14.5782 12.2529L8.86389 15.5863C8.33012 15.8976 7.67009 15.8976 7.13632 15.5863L1.42204 12.2529C0.895381 11.9457 0.571533 11.3819 0.571533 10.7722V5.22787C0.571533 4.61816 0.89538 4.05433 1.42204 3.7471L7.13632 0.413775ZM8.0001 11.1429C9.73585 11.1429 11.143 9.73575 11.143 8.00001C11.143 6.26426 9.73585 4.85715 8.0001 4.85715C6.26436 4.85715 4.85725 6.26426 4.85725 8.00001C4.85725 9.73575 6.26436 11.1429 8.0001 11.1429Z",
    fill: "#6D6584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f150977207ef7cc8bb1fcf492abbb4ac.svg";
export { ForwardRef as ReactComponent };